import React from 'react';

/**
 * The child space's empty state — `.empty` / `.empty-e` in the kid environment stylesheet.
 *
 * Not the operations console's `Empty`: the two sheets draw `.empty`
 * differently (big emoji, a heading, a sentence for a child), so the class
 * has one owner per environment, and this is the kid one. It says what is not
 * there yet, never that the child did something wrong (S07-PRI-05).
 */
export const KidEmpty: React.FC<{ icon: string; title: string; detail: string }> = ({
  icon,
  title,
  detail,
}) => (
  <div className="empty">
    <div className="empty-e" aria-hidden="true">
      {icon}
    </div>
    <h2 className="h2">{title}</h2>
    <p>{detail}</p>
  </div>
);
